import { useEffect } from 'react';

import { getRouteApi } from '@tanstack/react-router';
import toast from 'react-hot-toast';

import { useApplyCloudConnectPaymentMethod } from 'src/api/queries';

const routeApi = getRouteApi('__root__');

export const useVerifyCloudConnectPaymentMethod = () => {
  const navigate = routeApi.useNavigate();
  const search = routeApi.useSearch();
  const applyPaymentMethod = useApplyCloudConnectPaymentMethod();

  useEffect(() => {
    const redirectStatus =
      'redirect_status' in search ? search.redirect_status : undefined;
    const setupIntentId =
      'setup_intent' in search ? search.setup_intent : undefined;

    if (
      !setupIntentId ||
      'subscription_id' in search ||
      redirectStatus === 'failed' ||
      redirectStatus === 'failure'
    ) {
      return;
    }

    applyPaymentMethod.mutate(
      {
        setupIntentId,
      },
      {
        onSuccess: () => {
          void navigate({
            search: {
              setup_intent_client_secret: undefined,
              setup_intent: undefined,
              redirect_status: undefined,
            },
          });
          toast.success('Payment method updated');
        },
      }
    );
  }, []);

  return applyPaymentMethod;
};
